import { Modal } from "newui/components/ui/Modal";
import { useSelectedRfxParticipants } from "../../hooks/useSelectedRfxParticipants";

export interface ConfirmSendRfxModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	rfxId: number | string | null | undefined;
}

const ConfirmSendRfxModal = ({
	isOpen,
	onClose,
	onConfirm,
	rfxId,
}: ConfirmSendRfxModalProps) => {
	const participants = useSelectedRfxParticipants(rfxId);

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			iconType="info"
			// Deliberately says "suppliers" in the title even though the list
			// below also includes guests — requester's exact wording, kept
			// verbatim rather than "improved".
			title="You are going to issue this RFx to the following suppliers"
			// The list is one row per participant; `lg` is the shared modal's
			// default and reads fine for the handful of rows a typical RFx has,
			// but a large invite list scrolls inside the body rather than
			// stretching the modal — `xl` gives that list more breathing room
			// before it needs to.
			size="xl"
			primaryButton={{
				text: "Confirm",
				onClick: onConfirm,
			}}
			secondaryButton={{
				text: "Cancel",
				onClick: onClose,
			}}
		>
			<ul
				className="flex flex-col gap-2"
				data-testid="confirm-send-rfx-modal"
			>
				{participants.map((participant) => (
					<li
						key={`${participant.type}-${participant.email}`}
						className="flex items-center justify-between gap-4 border-b border-gray-100 py-2 text-sm last:border-b-0"
						data-testid="confirm-send-rfx-participant"
					>
						<span className="font-medium text-gray-900">{participant.name}</span>
						<span className="text-gray-500">{participant.email}</span>
					</li>
				))}
			</ul>
		</Modal>
	);
};

export { ConfirmSendRfxModal };
